<template>
  <no-ssr>
    <lazy-component class="yt-youtube-player" @show="init">
      <div
        class="yt-youtube-player__container"
        :data-plyr-provider="detectedTypeUrl.provider"
        :data-plyr-embed-id="detectedTypeUrl.id"
      ></div>
    </lazy-component>
  </no-ssr>
</template>

<script>
import noSSR from "vue-no-ssr";

export default {
  components: {
    "no-ssr": noSSR,
  },
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      plyrInstance: null,
    };
  },
  computed: {
    detectedTypeUrl() {
      const matches =
        this.src?.match(
          /(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be-nocookie.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/
        ) || [];

      let [, , , provider = "", , , id] = matches;

      if (provider.indexOf("youtu") > -1) {
        provider = "youtube";
      } else if(this.src?.indexOf('vimeo') > -1) {
        provider = "vimeo";
        id = this.src;
      }

      return {
        provider,
        id,
      };
    },
  },
  beforeDestroy() {
    this.plyrInstance?.destroy();
  },
  methods: {
    async init() {
      const { default: Plyr } = await import("plyr");

      this.$nextTick(() => {
        this.plyrInstance = new Plyr(
          // don't use ref, because it can be undefined at the moment
          this.$el.querySelector(".yt-youtube-player__container"),
          {
            disableContextMenu: true,
            youtube: {
              rel: 0,
              showinfo: 0,
              iv_load_policy: 3,
              modestbranding: 1,
              playsinline: 1,
              controls: 0,
              cc_load_policy: 0,
            },
          }
        );
      });
    },
  },
};
</script>

<style lang="scss">
@import "~plyr/dist/plyr.css";

$p: ".plyr";

.yt-youtube-player {
  font-family: var.$font-family-sf-pro-text;

  #{$p} {
    &--video {
      background: none;
      border-radius: var.$rounded-20;
    }

    &__control {
      &:hover {
        background-color: var.$green-hover;
      }

      &#{$p}__tab-focus {
        box-shadow: 0 0 0 5px rgba(var.$green-main, 0.5);
        outline: 0;
      }

      &[aria-expanded="true"] {
        background-color: var.$green-dark;
      }

      &--overlaid {
        background-color: rgba(var.$green-main, 0.8);

        &:hover,
        &:focus {
          background-color: var.$green-hover;
        }
      }
    }

    &--full-ui {
      input[type="range"] {
        color: var.$green-main;

        &.plyr__tab-focus::-webkit-slider-runnable-track {
          box-shadow: 0 0 0 5px rgba(var.$green-main, 0.5);
          outline: 0;
        }
      }
    }

    &__menu__container {
      #{$p}__control {
        margin-left: 0;

        &--back {
          margin-left: 7px;
        }

        &[role="menuitemradio"][aria-checked="true"] {
          &::before {
            background: var.$green-main;
          }
        }
      }
    }

    &__video-embed {
      border-radius: inherit;

      iframe {
        @include mixin.decor();
      }
    }
  }
}
</style>
